import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import treeMenu from "@/components/treeMenu/index.vue";
import { getSubjectList as _getSubjectList } from "@/api/managementCenter/themeManage";
import { queryRationPFVoList, queryRationHeadVo, queryRationGoodVoList, queryRationTuCaoVoList, submitRationHandle } from "@/api/management/score";
import request from "@/util/http";
import moment from "moment";
export default {
  name: "Router",
  components: {
    treeMenu: treeMenu
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      // month: '',
      dateRange: [],
      deptId: "",
      deptName: "",
      activeTab: "theme",
      themeList: [],
      themePagination: {
        current: 1,
        size: 10,
        total: 0
      },
      commentPagination: {
        current: 1,
        size: 10,
        total: 0
      },
      headData: {
        handleCnt: "",
        badCnt: "",
        reformCnt: "",
        serverAvgCnt: ""
      },
      activeTheme: {},
      goodTop5: [],
      badTop5: [],
      commentList: [],
      themeLoading: false,
      headLoading: false,
      topLoading: false,
      commentLoading: false,
      shortcutList: [{
        code: 1,
        title: "今日"
      }, {
        code: 2,
        title: "最近7天"
      }, {
        code: 3,
        title: "最近30天"
      }, {
        code: 4,
        title: "最近一年"
      }, {
        code: 5,
        title: "去年"
      }, {
        code: 6,
        title: "前年"
      }],
      activeShortcut: {
        code: 2,
        title: "最近7天"
      },
      shortcutDateRange: [moment().subtract("days", 6).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      dialogVisible: false,
      ruleValidate: {
        result: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }]
      },
      formValidate: {
        result: ""
      },
      handleRow: {},
      typeIndex: "",
      typeOrderBy: ""
    };
  },
  computed: {},
  created: function created() {
    this.initSubjectList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs.formValidate.validate(function (valid) {
        if (valid) {
          submitRationHandle({
            id: _this.handleRow.id,
            result: _this.formValidate.result
          }).then(function (_ref) {
            var data = _ref.data;

            if (data.code == 0) {
              _this.$message.success("操作成功");

              _this.initCommentList();

              _this.dialogVisible = false;
            } else {
              _this.$message.error(data.msg);
            }
          });
        }
      });
    },
    sortChange: function sortChange(_ref2) {
      var prop = _ref2.prop,
          order = _ref2.order;
      this.typeOrderBy = order ? order === "ascending" ? 1 : 0 : null;

      this.typeIndex = function () {
        switch (prop) {
          case "rations":
            return 2;

          case "deptName":
            return 3;

          case "serveName":
            return 4;

          case "zt":
            return 1;
        }
      }();

      this.getCommentList();
    },
    dialogClose: function dialogClose() {
      this.formValidate.result = "";
    },
    changeTab: function changeTab(tab) {
      this.activeTab = tab;
    },
    nodeId: function nodeId(data) {
      this.deptId = data.id;
      this.deptName = data.name;
      this.initContent();
    },
    shortcutClick: function shortcutClick(item) {
      this.activeShortcut = item;
    },
    initSubjectList: function initSubjectList() {
      this.themePagination.current = 1;
      this.getSubjectList(true);
    },
    getSubjectList: function getSubjectList(isInit) {
      var _this2 = this;

      var obj = {
        current: this.themePagination.current,
        size: this.themePagination.size
      };

      _getSubjectList(obj).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          if (data.data.records.length && _this2.themePagination.current == 1) {
            data.data.records.unshift({
              id: null,
              name: "全部"
            });
          }

          _this2.themeList = data.data.records;
          _this2.themePagination.total = data.data.total;

          if (isInit) {
            _this2.activeTheme = data.data.records[0] || {};
          }
        }
      });
    },
    getTop: function getTop() {
      var _this3 = this;

      this.topLoading = true;
      request.all([this.getGoodTop(), this.getBadTop()]).then(function (res) {
        if (res[0].data.code !== 0) {
          _this3.$message.error(res[0].data.msg);
        } else {
          _this3.goodTop5 = res[0].data.data;
        }

        if (res[1].data.code !== 0) {
          _this3.$message.error(res[1].data.msg);
        } else {
          _this3.badTop5 = res[1].data.data;
        }
      }).finally(function () {
        _this3.topLoading = false;
      });
    },
    getGoodTop: function getGoodTop() {
      var obj = {};

      if (this.shortcutDateRange.length) {
        obj.begin_date = this.shortcutDateRange[0];
        obj.end_date = this.shortcutDateRange[1];
      } else if (this.dateRange) {
        obj.begin_date = this.dateRange[0];
        obj.end_date = this.dateRange[1];
      }

      if (this.activeTab === "theme") {
        obj.subject_id = this.activeTheme.id;
      } else {
        obj.dept_id = this.deptId;
      }

      return queryRationGoodVoList(obj);
    },
    getBadTop: function getBadTop() {
      var params = {};

      if (this.shortcutDateRange.length) {
        params.begin_date = this.shortcutDateRange[0];
        params.end_date = this.shortcutDateRange[1];
      } else if (this.dateRange) {
        params.begin_date = this.dateRange[0];
        params.end_date = this.dateRange[1];
      }

      if (this.activeTab === "theme") {
        params.subject_id = this.activeTheme.id;
      } else {
        params.dept_id = this.deptId;
      }

      return queryRationTuCaoVoList(params);
    },
    changeTheme: function changeTheme(item) {
      this.activeTheme = item;
    },
    handleTopProgress: function handleTopProgress(type, num) {
      if (type === "good" && this.goodTop5.length > 0) {
        return num / this.goodTop5[0].cnt * 100;
      }

      if (type === "bad" && this.badTop5.length > 0) {
        return num / this.badTop5[0].cnt * 100;
      }

      return 0;
    },
    initCommentList: function initCommentList() {
      this.commentPagination.current = 1;
      this.getCommentList();
    },
    getCommentList: function getCommentList() {
      var _this4 = this;

      var obj = {
        current: this.commentPagination.current,
        size: this.commentPagination.size,
        typeIndex: this.typeIndex,
        typeOrderBy: this.typeOrderBy
      };

      if (this.shortcutDateRange.length) {
        obj.begin_date = this.shortcutDateRange[0];
        obj.end_date = this.shortcutDateRange[1];
      } else if (this.dateRange) {
        obj.begin_date = this.dateRange[0];
        obj.end_date = this.dateRange[1];
      }

      if (this.activeTab === "theme") {
        obj.subject_id = this.activeTheme.id;
      } else {
        obj.dept_id = this.deptId;
      }

      this.commentLoading = true;
      queryRationPFVoList(obj).then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          _this4.commentList = data.data.records;
          _this4.commentPagination.total = data.data.total;
        } else {
          _this4.$message.error(data.msg);
        }
      }).finally(function () {
        _this4.commentLoading = false;
      });
    },
    themePaginationChange: function themePaginationChange(current) {
      this.commentPagination.current = current;
      this.getCommentList();
    },
    commentPaginationChange: function commentPaginationChange(current) {
      this.themePagination.current = current;
      this.getSubjectList();
    },
    handleDataChange: function handleDataChange() {
      this.initContent();
    },
    initContent: function initContent() {
      this.initCommentList();
      this.getHeadData();
      this.getTop();
    },
    getHeadData: function getHeadData() {
      var _this5 = this;

      var params = {};

      if (this.shortcutDateRange.length) {
        params.begin_date = this.shortcutDateRange[0];
        params.end_date = this.shortcutDateRange[1];
      } else if (this.dateRange) {
        params.begin_date = this.dateRange[0];
        params.end_date = this.dateRange[1];
      }

      if (this.activeTab === "theme") {
        params.subject_id = this.activeTheme.id;
      } else {
        params.dept_id = this.deptId;
      }

      this.headLoading = true;
      queryRationHeadVo(params).then(function (_ref5) {
        var data = _ref5.data;

        if (data.code == 0) {
          _this5.headData = data.data;
        } else {
          _this5.$message.error(data.msg);
        }
      }).finally(function () {
        _this5.headLoading = false;
      });
    },
    goReply: function goReply(row) {
      this.handleRow = row;
      this.dialogVisible = true;
    },
    exportExcle: function exportExcle() {
      var _this6 = this;

      var params = {};

      if (this.shortcutDateRange.length) {
        params.begin_date = this.shortcutDateRange[0];
        params.end_date = this.shortcutDateRange[1];
      } else if (this.dateRange) {
        params.begin_date = this.dateRange[0];
        params.end_date = this.dateRange[1];
      }

      if (this.activeTab === "theme") {
        params.subject_id = this.activeTheme.id;
        params.subject_name = this.activeTheme.name;
        params.dept_name = "全校";
      } else {
        params.dept_id = this.deptId;
        params.dept_name = this.deptName;
        params.subject_name = "全部";
      }

      this.$DownLoadL("/admin/tHallServeRation/exportRationPFVoList?".concat(this.$qs.stringify(params)), null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this6.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this6.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  },
  watch: {
    activeTheme: function activeTheme(val) {
      this.initContent();
    },
    activeTab: function activeTab(val) {
      if (val === "theme") {
        this.deptId = "";
      } else if (val === "department") {
        this.deptId = "1";
        this.deptName = "全校";
      }

      this.initContent();
    },
    activeShortcut: function activeShortcut(val) {
      if (val.code) {
        this.dateRange = [];

        switch (val.code) {
          case 1:
            this.shortcutDateRange = [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 2:
            this.shortcutDateRange = [moment().subtract("days", 6).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 3:
            this.shortcutDateRange = [moment().subtract("days", 29).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 4:
            this.shortcutDateRange = [moment().subtract("days", 365).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 5:
            this.shortcutDateRange = [moment().year(moment().year() - 1).startOf("year").format("YYYY-MM-DD"), moment().year(moment().year() - 1).endOf("year").format("YYYY-MM-DD")];
            break;

          case 6:
            this.shortcutDateRange = [moment().year(moment().year() - 2).startOf("year").format("YYYY-MM-DD"), moment().year(moment().year() - 2).endOf("year").format("YYYY-MM-DD")];
            break;

          default:
            this.shortcutDateRange = [];
            break;
        }

        this.handleDataChange();
      } else {
        this.shortcutDateRange = [];
      }
    },
    dateRange: function dateRange(val) {
      if (!val) {
        this.activeShortcut = {
          code: 2,
          title: "最近7天"
        };
        return;
      }

      if (val.length > 0) {
        this.activeShortcut = {};
      }
    }
  },
  filters: {}
};